<template>
  <v-container grid-list-xl fluid>
    <v-layout wrap align-center justify-center>
      <v-btn
        large
        color="primary darken-1"
        style="margin: 10px"
      @click="isRestaurant = true">
      <v-icon class="mr-1">mdi-chef-hat</v-icon>
        {{ $t('auth.isRestaurant') }}
      </v-btn>
      <v-btn
        large
        color="primary darken-1"
        @click="isProvider = true">
        <v-icon class="mr-1">mdi-store</v-icon>
        {{ $t('auth.isProvider') }}
      </v-btn>
    </v-layout>

    <!-- Sign in modal for Restaurant -->
    <v-dialog v-model="isRestaurant" persistent max-width="420px">
      <v-card flat>
        <v-btn
          fab
          text
          x-small
          color="primary darken-1"
          class="mr-3 mt-3"
          style="float: right"
          @click="closeLoginRestaurant"
        >
          <v-icon size="large">mdi-close-circle</v-icon>
        </v-btn>
        <v-card-title>
          <span class="title">
            {{ $t('auth.login') }}
          </span>
        </v-card-title>
        <v-card-subtitle>
          <span class="subheading">
            {{ $t('auth.loginAccountType', {type: $t('auth.restaurant')}) }}
          </span>
        </v-card-subtitle>
        <v-card-text>
          <v-form v-model="isValid" ref="loginRestaurant">
            <v-row>
              <v-col>
                <v-text-field
                  data-cy="email-restaurant"
                  v-model="form.email"
                  :rules="rules.email"
                  :label="$t('auth.labels.email')"
                  required />
                <v-text-field
                  data-cy="password-restaurant"
                  v-model="form.password"
                  :rules="rules.password"
                  :label="$t('auth.labels.password')"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  required>
                </v-text-field>
                <v-btn
                  small
                  text
                  class="pl-0"
                  color="secondary darken-1"
                  to="/recovery-password">
                  {{ $t('auth.forgotPassword') }}
                </v-btn>
                <v-btn
                  data-cy="signIn-restaurant"
                  depressed
                  block
                  class="mt-8"
                  color="primary darken-1"
                  @click="login">
                  {{$t('auth.login')}}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-row class="justify-center">
                  <span class="body-2">
                    {{ $t('auth.noAccount') }}
                  </span>
                </v-row>
                <v-row class="justify-center">
                  <v-btn
                    data-cy="register-restaurant"
                    small
                    text
                    color="primary darken-1"
                    :to="{name: 'Register'}">
                    {{ $t('auth.labels.register') }}
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Sign in modal for Provider -->
    <v-dialog v-model="isProvider" persistent max-width="420px">
      <v-card flat>
        <v-btn
          fab
          text
          x-small
          color="primary darken-1"
          class="mr-3 mt-3"
          style="float: right"
          @click="closeLoginProvider"
        >
          <v-icon size="large">mdi-close-circle</v-icon>
        </v-btn>
        <v-card-title>
          <span class="title">
            {{ $t('auth.login') }}
          </span>
        </v-card-title>
        <v-card-subtitle>
          <span class="subheading">
            {{ $t('auth.loginAccountType', {type: $t('auth.provider')}) }}
          </span>
        </v-card-subtitle>
        <v-card-text>
          <v-form v-model="isValid" ref="loginProvider">
            <v-row>
              <v-col>
                <v-text-field
                  data-cy="email-provider"
                  v-model="form.email"
                  :rules="rules.email"
                  :label="$t('auth.labels.email')"
                  required />
                <v-text-field
                  data-cy="password-provider"
                  v-model="form.password"
                  :rules="rules.password"
                  :label="$t('auth.labels.password')"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  required>
                </v-text-field>
                <v-btn
                  small
                  text
                  class="pl-0"
                  color="secondary darken-1"
                  to="/recovery-password?provider=true">
                  {{ $t('auth.forgotPassword') }}
                </v-btn>
                <v-btn
                  data-cy="signIn-provider"
                  depressed
                  block
                  class="mt-8"
                  color="primary darken-1"
                  @click="login">
                  {{$t('auth.login')}}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-row class="justify-center">
                  <span class="body-2">
                    {{ $t('auth.noAccount') }}
                  </span>
                </v-row>
                <v-row class="justify-center">
                  <v-btn
                    data-cy="register-restaurant"
                    small
                    text
                    color="primary darken-1"
                    :to="{name: 'Register',
                        query: {
                          provider: true
                        }
                      }">
                    {{ $t('auth.labels.register') }}
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Loading overlay -->
    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Toast -->
    <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="3000">
    <span class="body-1">
      {{ snackbarText }}
    </span>
  </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import i18n from '@/lang'
export default {
  name: 'Login',
  data () {
    return {
      overlay: false,
      showPassword: false,
      isValid: false,
      isRestaurant: false,
      isProvider: false,
      snackbar: false,
      snackbarText: '',
      snackBarColor: null,
      form: {
        email: '',
        password: '',
        userProvider: false
      },
      rules: {
        email: [
          v => !!v || this.$t('validations.email.required'),
          v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || this.$t('validations.email.valid')
        ],
        password: [v => !!v || this.$t('validations.password')]
      }
    }
  },
  methods: {
    ...mapActions(['login/signIn']),
    async login () {
      if (this.isValid) {
        this.overlay = true
        try {
          if (this.isProvider === true) {
            this.form.userProvider = true
            this.$store.commit('setUserprovider')
          } else {
            this.form.userProvider = false
            this.$store.commit('clearUserprovider')
          }

          await this['login/signIn'](this.form)
          i18n.locale = this.$store.state.login.user.language || 'es'
          if (this.$store.state.userProvider) {
            this.$router.push({ name: 'SelectProvider' })
          } else {
            this.$router.push({ name: 'SelectRestaurant' })
          }
        } catch (e) {
          this.showSnackBar(e.message, false)
        }
        this.overlay = false
      }
    },
    closeLoginRestaurant () {
      this.isRestaurant = false
      this.form = {
        email: '',
        password: '',
        userProvider: false
      }
      this.$refs.loginRestaurant.reset()
    },
    closeLoginProvider () {
      this.isProvider = false
      this.form = {
        email: '',
        password: '',
        userProvider: false
      }
      this.$refs.loginProvider.reset()
    },
    showSnackBar (message, success) {
      this.snackBarColor = success ? 'success darken-1' : 'error darken-1'
      this.snackbarText = message
      this.snackbar = true
    }
  }
}
</script>

<style lang="css" scoped>
</style>
